import { initJsFluidMultipliers } from '../lib/fluidSizings';
import { embedHsForm } from '../lib/hsForms';

export function initRequestQuotePage() {
  embedHsForm('#hubspotFormContainer');

  console.log('📄 Request a quote page initialized.');
}
